import useSecureFetch from "./useSecureFetch";
import AppSettings from "../../AppSettings";

export default function useRequestMetrics(owner, unit, from, to, callback) {
  const url = `${AppSettings.RequestMetrics}?owner=${owner}&from=${from}&to=${to}&unit=${unit}`;
  const result = useSecureFetch(url, null, url, callback);
  return result;
}
